
export function getLocalitiesFromNovaPoshtaUrl(q: string) {
  return `/delivery_third_party/nova_poshta/settlements/?q=${encodeURIComponent(q)}`;
}

export function getChainsUrl() {
  return `/retail_chains/?accepts_excise_payment_online=true`;
}
